import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_CAROUSEL_CONFIGURATION = createFcmDetails('carousel_configuration', {
	owner: 'TBD',
	context: 'Petition discover page (carousel)',
	description: 'Defines the configuration of the carousel',
	import: false,
	template: {
		maxPetitionsToShow: 60,
		minPetitionsToShow: {
			production: 5,
			staging: 5,
			demo: 3,
			development: 3,
		},
		promotedInsertionInterval: 2,
		userRecommendedModelName: undefined,
		cardFetchStrategies: [
			'promoted',
			'user_based_recommendations',
			'petition_based_recommendations',
			'topic_petitions',
			'popular_weekly',
		],
	},
});
